if (!customElements.get('products-slider')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var desktopColumns = +this.getAttribute('data-items');
      var spaceBetween = parseFloat(this.getAttribute('data-space-between').replace('rem', '')) * 10;
      this.sliderInstance = new window.FoxTheme.Carousel(this, {
        slidesPerView: 1.2,
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: desktopColumns,
          },
        },
        loop: true,
        roundLengths: true,
        threshold: 2,
      });
      this.sliderInstance.init();
    }
  }
  customElements.define('products-slider', CollectionList);
}
